module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"searchClustersLabel":"browse clusters | browse clusters (1) | browse {n} clusters","clustersLabel":"Text Reuse Clusters","clusterLabel":"Text Reuse Cluster"}}')
  delete Component.options._Ctor
}
